import { Component, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import { TripPurposesService } from '../../service/trip-purposes.service';

@Component({
  selector: 'app-appointment-type-mapper-list',
  templateUrl: './appointment-type-mapper-list.component.html',
  styleUrls: ['./appointment-type-mapper-list.component.css']
})
export class AppointmentTypeMapperListComponent implements OnInit {
  mappers: any = [];
  finalMapper = [];
  fundingSources: any = [];
  preFundingSources = []
  search;
  subMenuTab = 'mapper';

  constructor(
    private corporateService: CorporateService,
    private tripPurposesService: TripPurposesService
  ) { }

  ngOnInit() {
    this.getFundingSource();
    this.getAppointmentTypesMappersList();
  }

  getAppointmentTypesMappersList() {
    this.tripPurposesService
      .getAppintmentTypesMappers()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.mappers = data;
        }
      });
  }
  
  getFundingSource() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.fundingSources = data;
          this.preFundingSources = data.reduce((obj, item) => (obj[item._id] = item, obj), {})
        }
      });
  }

  ngOnDestroy(): void {
  }
}
